__turbopack_context__.v({
  "line": "RepairDetailsContactSummary-module-scss-module__mc98zG__line",
  "wrapper": "RepairDetailsContactSummary-module-scss-module__mc98zG__wrapper",
});
